//import axios from 'axios'
import store from '../store'


export default {  
    created () {    
        document.title = 'Eicoh Agenda';
    },
    methods: {
        hasHistory () { 
            return window.history.length > 2 
        },
        getCustomers(){                   
            var url = this.$store.state.activeAPIurl + "api/customers";                                    
            console.log(url);                    
            this.axios.post(url,{filter: this.$store.state.customerFilter, g: this.$store.state.usuario.guid},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                       
                store.commit('saveCustomers',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getAppConfig(){                   
            var url = this.$store.state.activeAPIurl + "api/appconfig";                                    
            console.log(url);                    
            this.axios.post(url)
            .then(response => {      
                console.log(response); 
                //store.state.appconfig = response.data[0];            
                store.commit('saveAppConfig',response.data[0]);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        login(user,pass){
            var url = this.$store.state.activeAPIurl + "api/login";                                    
            console.log(url);                    
            this.axios.post(url,{user: user, pass: pass})
            .then(response => {      
                console.log(response); 
                if (response.data.length > 0){
                    store.commit('saveLogin',response.data[0]);
                    this.$router.push("Agenda"); 
                } else {
                    store.state.loginError = true;
                    store.state.loginErrorMsg = 'Error en inicio de sesión';
                }  
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getJobs(){                   
            var url = this.$store.state.activeAPIurl + "api/jobs";                                    
            console.log(url);                    
            this.axios.post(url,{g: this.$store.state.usuario.guid, custFilter: this.$store.state.customerFilter},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                            
                store.commit('saveJobs',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
            this.axios.post(url,{g: this.$store.state.usuario.guid, custFilter: ''},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                            
                store.commit('saveAllJobs',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            }); 
        },
        getFamilias(){                   
            var url = this.$store.state.activeAPIurl + "api/familias";                                    
            console.log(url);                    
            this.axios.post(url,{g: this.$store.state.usuario.guid},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                            
                store.commit('saveFamilias',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        }, 
        getJobTasks(jobNo){                   
            var url = this.$store.state.activeAPIurl + "api/jobtask";                                    
            console.log(url);                    
            this.axios.post(url,{jobNo: jobNo, g: this.$store.state.usuario.guid},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                       
                store.commit('saveJobTasks',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        //obsoleto
        async getJobTasksAsync(jobNo){     
            try {              
                var url = this.$store.state.activeAPIurl + "api/jobtask";                                    
                console.log(url);                    
                let res = await this.axios.post(url,{jobNo: jobNo, g: this.$store.state.usuario.guid},{headers: {"Content-Type": "application/json"}})
                return res.data;      
            } catch (err) {
                console.error(err);
            }
        },
        getJobTaskItemUom(itemNo){                   
            var url = this.$store.state.activeAPIurl + "api/uoms";                                    
            console.log(url);                    
            this.axios.post(url,{g: this.$store.state.usuario.guid, itemNo : itemNo},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                       
                store.commit('saveUoms',response.data);
                if ((response.data) && (response.data.length == 1)){
                    store.commit('saveUom',response.data[0].code);
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getWorkTypes(){                   
            var url = this.$store.state.activeAPIurl + "api/worktypes";                                    
            console.log(url);                    
            var weekday = new Array(7);
            weekday[0] = "D";
            weekday[1] = "L";
            weekday[2] = "M";
            weekday[3] = "X";
            weekday[4] = "J";
            weekday[5] = "V";
            weekday[6] = "S";
            var h = new Date().getHours();
            if (h<10) h = '0' + h;
            var m = new Date().getMinutes();
            if (m<10) m = '0' + m;
            var currHour = new Date("01/01/1754 " + h + ':' + m + ':00');
            console.log(currHour);
            var fechaParte = new Date(this.$store.state.fechaParte)
            var n = weekday[fechaParte.getDay()];
            this.axios.post(url,{day : n, familia: this.$store.state.familia, g: this.$store.state.usuario.guid},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                            
                /*for (var i = 0; i < response.data.length; ){
                    if (!((new Date(response.data[i].fromHour) < currHour) && (new Date(response.data[i].toHour) > currHour))){
                        response.data.splice(i,1);
                    } else {
                        i++;
                    }
                }*/
                
                store.commit('saveWorkTypes',response.data);

            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getResources(){                   
            var url = this.$store.state.activeAPIurl + "api/resources/list";                                    
            console.log(url);                    
            this.axios.post(url,{g: this.$store.state.usuario.guid},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                            
                store.commit('saveResources',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        // eslint-disable-next-line
        getOrigenes(jobNo){                   
            var url = this.$store.state.activeAPIurl + "api/origenes";                                    
            console.log(url);                    
            var jobNoCheck = jobNo == undefined ? '' : jobNo;
            //var jobNoCheck = '';
            this.axios.post(url,{g: this.$store.state.usuario.guid, jobNo: jobNoCheck},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                            
                store.commit('saveOrigenes',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getDestinos(){                   
            var url = this.$store.state.activeAPIurl + "api/destinos";                                    
            console.log(url);                    
            this.axios.post(url,{g: this.$store.state.usuario.guid},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                            
                store.commit('saveDestinos',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getResiduos(){                   
            var url = this.$store.state.activeAPIurl + "api/residuos";                                    
            console.log(url);                    
            this.axios.post(url,{g: this.$store.state.usuario.guid},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                response.data.sort(function (a, b) {
                    if (a.desc > b.desc) {
                      return 1;
                    }
                    if (a.desc < b.desc) {
                      return -1;
                    }
                    // a must be equal to b
                    return 0;
                  });           
                  console.log(response);   
                store.commit('saveResiduos',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getCodInternos(){                   
            var url = this.$store.state.activeAPIurl + "api/codinterno";                                    
            console.log(url);                    
            this.axios.post(url,{g: this.$store.state.usuario.guid, job : this.$store.state.proyecto},{headers: {"Content-Type": "application/json"}})
            .then(response => {        
                if (response.status == 204) store.state.dialogLogout = true;       
                console.log(response);   
                store.commit('saveCodsIntClientes',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getJobInputs(){                   
            var url = this.$store.state.activeAPIurl + "api/jobtimeinput/jobtimeinputlist";                                    
            console.log(url);                    
            this.axios.post(url,{ 
                g: this.$store.state.usuario.guid, 
                user: this.$store.state.usuario.user
            },
            {headers: {"Content-Type": "application/json"}})
            .then(response => {   
                if (response.status == 204) store.state.dialogLogout = true;   
                console.log(response);                       
                store.commit('saveEvents',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getJobInputSummary(){                   
            var url = this.$store.state.activeAPIurl + "api/jobtimeinput/JobTimeInputSummary";                                    
            console.log(url);                    
            this.axios.post(url,{ 
                g: this.$store.state.usuario.guid, 
                user: this.$store.state.usuario.user
            },
            {headers: {"Content-Type": "application/json"}})
            .then(response => {   
                if (response.status == 204) store.state.dialogLogout = true;   
                console.log(response);                       
                store.commit('saveEvents',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getUsers(){                   
            var url = this.$store.state.activeAPIurl + "api/users";                                    
            console.log(url);                    
            this.axios.post(url,{ g: this.$store.state.usuario.guid},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);              
                if (response.data.length){
                    response.data.sort(function(a, b) {
                        if(a.Name < b.Name) { return -1; }
                        if(a.Name > b.Name) { return 1; }
                        return 0;
                    });
                }
                store.commit('saveUsers',response.data);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getDocumentRelation() {
            this.axios.post(this.$store.state.activeAPIurl + 'api/documentusers/get',  
              {user : this.$store.state.usuario.user, docDate: this.$store.state.fechaParte},
              { headers: {"Content-Type": "application/json" }})
              .then((response) => {
                if (response.status == 200) {    
                    console.log(response);
                    store.commit('saveRelations',response.data.value);
                    if ((response.data.value.length > 0) && (this.$store.state.relation == "")){
                        //alert('Existen partes abiertos asociados a su usuario. Seleciónelo para relacionar el nuevo parte con el ya abierto')
                        store.commit('saveGlobalAlert',true);
                        //store.commit('saveGlobalAlertContent','Existen partes abiertos asociados a su usuario. Selecciónelo para relacionar el nuevo parte con el ya abierto');
                        store.commit('saveGlobalAlertContent','Existen partes abiertos asociados a su usuario.');
                    }
                }
            })
        },
        createDocumentRelation(inputNo,shipmentNo) {
            var relations = [];
            for (var i = 0; i < this.$store.state.user.length; i++){
                var relation = {
                    Documento: inputNo,
                    Ruta : shipmentNo,
                    Tipo: "RelacionParte",
                    Usuario: this.$store.state.user[i]
                }   
                relations.push(relation);
            }
            this.axios.post(this.$store.state.activeAPIurl + 'api/documentusers/create', 
              relations,
              { headers: {"Content-Type": "application/json" }})
              .then((response) => {
                if (response.status == 200) {    
                    console.log(response);
                }
            })
        },
        SetSignature(signatureImage, type, docNo, name, lineNo) {
            if (!signatureImage) return;            
            let base64strLength = JSON.stringify(signatureImage).length
            let base64strWithoutHeader = JSON.stringify(signatureImage).substring(23, base64strLength-1);
            var signature = {
                signatureImage: "",
                docNo: "",
                lineNo: "",
                recourceName: "",
                type: 0
            }          
            signature.signatureImage = base64strWithoutHeader;
            signature.docNo = docNo;          
            signature.recourceName = name;
            signature.lineNo = lineNo;
            signature.type = type;
      
            this.axios.post(this.$store.state.activeAPIurl + 'api/signature', 
              JSON.stringify(signature), 
              { headers: {"Content-Type": "application/json" }})
              .then((response) => {
                if (response.status == 200) {    
                    console.log(response);
                }
            })
        },
        createAditionalResourcesRelation(inputNo,resourcesAdditional) {
            var relations = [];
            for (var i = 0; i < resourcesAdditional.length; i++){
                var relation = {
                    Documento: inputNo,
                    Ruta : resourcesAdditional[i],
                    Tipo: "RecursoAdicional",
                    Usuario: ''
                }   
                relations.push(relation);
            }
            this.axios.post(this.$store.state.activeAPIurl + 'api/resources/createAditional', 
              relations,
              { headers: {"Content-Type": "application/json" }})
              .then((response) => {
                if (response.status == 200) {    
                    console.log(response);
                }
            })
        },
        getResourcesAditionalRelations(inputNo){                   
            var url = this.$store.state.activeAPIurl + "api/resources/listAditionalAssigned";                                    
            console.log(url);   
            this.axios.post(url,{g: this.$store.state.usuario.guid, inputNo: inputNo},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);      
                var resAdd = [];
                response.data.forEach(resAd => {
                    resAdd.push(resAd.no);
                });                      
                
                store.commit('saveResourcesAditional',resAdd);
                if (store.state.parteDetalleObject){
                    store.state.parteDetalleObject.resourcesAditional = resAdd;
                    store.commit('saveParteDetalleObject',store.state.parteDetalleObject);
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        clearAdditionalUsers(inputNo){                   
            var url = this.$store.state.activeAPIurl + "api/documentusers/cleanRelations";                                    
            console.log(url);   
            this.axios.post(url,{g: this.$store.state.usuario.guid, doc: inputNo},{headers: {"Content-Type": "application/json"}})
            .then(response => {    
                console.log(response)  ;
            })
            .catch(function (error) {
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        getAdditionalUsers(inputNo){                   
            var url = this.$store.state.activeAPIurl + "api/documentusers/related";                                    
            console.log(url);   
            this.axios.post(url,{g: this.$store.state.usuario.guid, doc: inputNo},{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                if (response.status == 204) store.state.dialogLogout = true;    
                var usrAdd = [];
                response.data.value.forEach(res => {
                    usrAdd.push(res.Usuario);
                });                      
                console.log(usrAdd);
                store.commit('saveUser',usrAdd);
                /*if (store.state.parteDetalleObject){
                    store.state.parteDetalleObject.resourcesAditional = usrAdd;
                    store.commit('saveParteDetalleObject',store.state.parteDetalleObject);
                }*/
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });         
        },
        sendImages(inputNo){
            if (this.$store.state.images == undefined) return;
            var fd = new FormData();                            
            for(var i = 0; i<this.$store.state.images.length; i++){                
                fd.append('files',this.$store.state.images[i])
            }
            this.axios.post(this.$store.state.activeAPIurl + 'api/images/upload',     
            fd,
            { headers: {"inputNo" : inputNo, "Content-Type": "multipart/form-data"}})
            .then((response) => {
                if (response.status == 200) {
                    this.$store.state.images = [];                  
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });                       
        },
        formatDate(date){
            if (date){
                var d = new Date(date),
                    month = '' + (d.getMonth() + 1),
                    day = '' + d.getDate(),
                    year = d.getFullYear();
                if (month.length < 2) 
                    month = '0' + month;
                if (day.length < 2) 
                    day = '0' + day;
                return [year, month, day].join('-');
            } else{
                return '';
            }
        },
        formatTime(time){
            if (time){
                var d = new Date(time),
                    hour = '' + d.getHours(),
                    minutes = '' + d.getMinutes();                
                if (hour.length < 2) 
                    hour = '0' + hour;
                if (minutes.length < 2) 
                    minutes = '0' + minutes;
                return [hour, minutes].join(':');
            } else {
                return '';
            }
        },
        timeToDateTime(dStr){
            if (dStr){
                var now = new Date(this.$store.state.fechaParte.valueOf());
                now.setHours(dStr.substr(0,dStr.indexOf(":")));
                now.setMinutes(dStr.substr(dStr.indexOf(":")+1));
                now.setSeconds(0);
                now = new Date(now.valueOf() - now.getTimezoneOffset() * 60000); 
                //Ajuste para GMT+1 / 0 entre la app y Nav
                return now;
            } else {
                return new Date(null);
            }
        },
        createDocument(){  
            var companions = this.$store.state.user;
            var header ={
                inputNo : '',
                creationDate : this.formatDate(this.$store.state.fechaParte),
                postingDate : this.formatDate(this.$store.state.fechaParte),
                user : this.$store.state.usuario.user,
                shipmentNo : this.$store.state.relation,
                driver : this.$store.state.driver,
                revision: this.$store.state.revision,
                Lines : []
            }            
            var multipleResources = false;
            if (this.$store.state.resourcesAditional.length != 0)
                multipleResources = true;
            for (var i = 0; i < this.$store.state.lineasParte.length; i++){
                var line = {
                    inputNo : '',
                    lineNo : this.$store.state.lineasParte[i].lineNo, 
                    jobNo : this.$store.state.lineasParte[i].jobNo,
                    jobTaskNo : this.$store.state.lineasParte[i].jobTaskNo,
                    timeCount : this.$store.state.lineasParte[i].hourCount,
                    jobTaskItemNo : this.$store.state.lineasParte[i].jobTaskItemNo,
                    invoiceableTimeCount : this.$store.state.lineasParte[i].invoiceableCount,
                    invoiceableTimeCountUom : this.$store.state.lineasParte[i].invoiceableCountUom,
                    familia : this.$store.state.lineasParte[i].familia,                    
                    workType : this.$store.state.lineasParte[i].workType,
                    startTime : this.timeToDateTime(this.$store.state.lineasParte[i].startTime),
                    endTime : this.timeToDateTime(this.$store.state.lineasParte[i].endTime),
                    startTimeInvoiceable : this.timeToDateTime(this.$store.state.lineasParte[i].startTimeInvoiceable),
                    endTimeInvoiceable : this.timeToDateTime(this.$store.state.lineasParte[i].endTimeInvoiceable),
                    resource : this.$store.state.lineasParte[i].resource,
                    origen:  this.$store.state.lineasParte[i].origen,
                    destino:  this.$store.state.lineasParte[i].destino,
                    residuo: this.$store.state.lineasParte[i].residuo,
                    albaranFisico: this.$store.state.lineasParte[i].albaranFisico,
                    dieta: this.$store.state.lineasParte[i].dieta,
                    codIntCliente:  this.$store.state.lineasParte[i].codIntCliente,
                    taskDescription:  this.$store.state.lineasParte[i].taskDescription,
                    note:  this.$store.state.lineasParte[i].note,
                    adicional: false,
                    invoiceableLine : this.$store.state.lineasParte[i].invoiceableLine,
                    resourceLine : this.$store.state.lineasParte[i].resourceLine
                }
                if ((line.taskDescription == '') && ((this.$store.state.taskDescription != '') && (this.$store.state.taskDescription != undefined))){
                    line.taskDescription = this.$store.state.taskDescription;
                }
                header.Lines.push(line);
                if (multipleResources && this.$store.state.driver){ //Solo para conductores
                    //Si hay varios recursos maquina, buscamos la linea del recurso persona para copiarla
                    if (line.invoiceableTimeCountUom == ''){
                        for (var j = 0; j < this.$store.state.resourcesAditional.length; j++){
                            /*var lineNo = 10000;
                            if (header.Lines.length > 0){
                                lineNo += header.Lines[header.Lines.length-1].lineNo;
                            }*/
                            var lineCopy = JSON.parse(JSON.stringify(line));
                            lineCopy.lineNo = this.$store.state.lineasParte[i].lineNo + ((j+1)*100);
                            lineCopy.startTime = this.timeToDateTime(this.$store.state.lineasParte[i].startTime),
                            lineCopy.endTime = this.timeToDateTime(this.$store.state.lineasParte[i].endTime),
                            lineCopy.startTimeInvoiceable = this.timeToDateTime(this.$store.state.lineasParte[i].startTimeInvoiceable),
                            lineCopy.endTimeInvoiceable = this.timeToDateTime(this.$store.state.lineasParte[i].endTimeInvoiceable),
                            lineCopy.invoiceableTimeCount = 0;
                            lineCopy.invoiceableTimeCountUom = '';
                            lineCopy.resource = this.$store.state.resourcesAditional[j];
                            lineCopy.adicional = true;
                            lineCopy.resourceLine = line.lineNo;
                            header.Lines.push(lineCopy);
                            /*
                            if (lineCopy.invoiceableLine > 0){
                                var invoLine = header.Lines.find(lin =>{
                                    return (lin.lineNo == lineCopy.invoiceableLine);
                                });
                                invoLine.timeCount += parseFloat(lineCopy.timeCount);
                            }
                            */
                        }
                        //multipleResources = false;
                    }
                }
            }
            var url = this.$store.state.activeAPIurl + "api/jobtimeinput/createjobtimeinput";
            var auxthis = this;
            auxthis.$store.commit('saveisLoading',true);
            this.axios.post(url,header,{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                console.log(response);
                var notifyCustomer = false;
                if (response.status == 200){                    
                    this.SetSignature(this.$store.state.signatureOrder,'Cabecera',response.data.inputNo,this.$store.state.usuario.name,0);
                    if (this.$store.state.signatureCustomer != ''){
                        notifyCustomer = true;
                        this.SetSignature(this.$store.state.signatureCustomer,'Cliente',response.data.inputNo,this.$store.state.usuario.name,0);
                    }
                    if (this.$store.state.signatureServices != ''){
                        this.SetSignature(this.$store.state.signatureServices,'Servicios',response.data.inputNo,this.$store.state.usuario.name,0);
                    }
                    for (i = 0; i< this.$store.state.lineasParte.length; i++){
                        this.SetSignature(this.$store.state.lineasParte[i].signatureStart,'Desde',response.data.inputNo,this.$store.state.usuario.name,(i+1)*10000);
                        this.SetSignature(this.$store.state.lineasParte[i].signatureEnd,'Hasta',response.data.inputNo,this.$store.state.usuario.name,(i+1)*10000);
                    }
                    if (companions.length > 0)
                        this.createDocumentRelation(response.data.inputNo,response.data.shipmentNo);
                    if (this.$store.state.resourcesAditional.length != 0){
                        this.createAditionalResourcesRelation(response.data.inputNo,this.$store.state.resourcesAditional);
                    }
                    this.sendImages(response.data.inputNo);
                    if (notifyCustomer){
                        //
                    }
                    this.$router.push('Agenda');
                    this.$store.commit('resetDataAfterSuccessfulCreation');                    
                    this.getJobInputs();
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);
                if ((error.response) && (error.response.data))
                {
                    alert(error.response.data);
                }
            })
            .finally(function () {         
                auxthis.$store.commit('saveisLoading',false);
            });
        },
        updateDocument(){                        
            var header ={
                etag : this.$store.state.parteDetalleObject.["@odata.etag"],
                inputNo : this.$store.state.parteDetalleObject.inputNo,
                //creationDate : this.$store.state.fechaParte,
                //postingDate : this.$store.state.fechaParte,
                creationDate : this.formatDate(this.$store.state.parteDetalleObject.creationDate),
                postingDate : this.formatDate(this.$store.state.parteDetalleObject.postingDate),
                user : this.$store.state.parteDetalleObject.user,
                driver : this.$store.state.driver,
                shipmentNo : this.$store.state.parteDetalleObject.shipmentNo,
                //Se eliminan los datos de cabecera de la string base64, da error en nav
                //signature: this.$store.state.signatureOrder.substring(22),
                revision: this.$store.state.revision,
                Lines : []
            }            
            var multipleResources = false;
            if (this.$store.state.resourcesAditional.length != 0)
                multipleResources = true;
            for (var i = 0; i < this.$store.state.lineasParte.length; i++){
                var line = {
                    etag : this.$store.state.lineasParte[i].etag,
                    inputNo : header.inputNo,
                    lineNo : this.$store.state.lineasParte[i].lineNo,
                    jobNo : this.$store.state.lineasParte[i].jobNo,
                    jobTaskNo : this.$store.state.lineasParte[i].jobTaskNo,
                    timeCount : this.$store.state.lineasParte[i].hourCount,
                    jobTaskItemNo : this.$store.state.lineasParte[i].jobTaskItemNo,
                    invoiceableTimeCount : this.$store.state.lineasParte[i].invoiceableCount,
                    invoiceableTimeCountUom : this.$store.state.lineasParte[i].invoiceableCountUom,
                    familia : this.$store.state.lineasParte[i].familia,                    
                    workType : this.$store.state.lineasParte[i].workType,
                    startTime : this.timeToDateTime(this.$store.state.lineasParte[i].startTime),
                    endTime : this.timeToDateTime(this.$store.state.lineasParte[i].endTime), 
                    startTimeInvoiceable : this.timeToDateTime(this.$store.state.lineasParte[i].startTimeInvoiceable),
                    endTimeInvoiceable : this.timeToDateTime(this.$store.state.lineasParte[i].endTimeInvoiceable),                   
                    resource : this.$store.state.lineasParte[i].resource,
                    origen:  this.$store.state.lineasParte[i].origen,
                    destino:  this.$store.state.lineasParte[i].destino,
                    residuo: this.$store.state.lineasParte[i].residuo,
                    albaranFisico: this.$store.state.lineasParte[i].albaranFisico,
                    dieta: this.$store.state.lineasParte[i].dieta,
                    codIntCliente:  this.$store.state.lineasParte[i].codIntCliente,
                    taskDescription:  this.$store.state.lineasParte[i].taskDescription,
                    shipmentNo : this.$store.state.parteDetalleObject.shipmentNo,
                    note:  this.$store.state.lineasParte[i].note,
                    adicional: this.$store.state.lineasParte[i].adicional,
                    invoiceableLine : this.$store.state.lineasParte[i].invoiceableLine,
                    resourceLine : this.$store.state.lineasParte[i].resourceLine
                }
                header.Lines.push(line);
                if (multipleResources && this.$store.state.driver){ //Solo para conductores
                    //Si hay varios recursos maquina, buscamos la linea del recurso persona para copiarla, 
                    //comprobando antes si ya existe el recurso adicional en las lineas, o si se ha borrado alguno
                    if ((line.invoiceableTimeCountUom == '') && !(line.adicional)){
                        for (var j = 0; j < this.$store.state.resourcesAditional.length; j++){
                            //var findResult = this.$store.state.lineasParte.find(lin => (lin.resource == this.$store.state.resourcesAditional[j]) && (lin.adicional) && (lin.invoiceableCountUom == ''));
                            var findResult = this.$store.state.lineasParte.find(lin => (lin.resourceLine == line.lineNo));
                            if (!findResult){
                                /*var lineNo = 10000;
                                if (header.Lines.length > 0){
                                    lineNo += header.Lines[header.Lines.length-1].lineNo;
                                }*/
                                var lineCopy = JSON.parse(JSON.stringify(line));
                                lineCopy.etag = '';
                                lineCopy.lineNo = this.$store.state.lineasParte[i].lineNo + ((j+1)*100);
                                lineCopy.startTime = this.timeToDateTime(this.$store.state.lineasParte[i].startTime),
                                lineCopy.endTime = this.timeToDateTime(this.$store.state.lineasParte[i].endTime),
                                lineCopy.startTimeInvoiceable = this.timeToDateTime(this.$store.state.lineasParte[i].startTimeInvoiceable),
                                lineCopy.endTimeInvoiceable = this.timeToDateTime(this.$store.state.lineasParte[i].endTimeInvoiceable),
                                lineCopy.invoiceableTimeCount = 0;
                                lineCopy.invoiceableTimeCountUom = '';
                                lineCopy.resource = this.$store.state.resourcesAditional[j];
                                lineCopy.adicional = true;
                                lineCopy.resourceLine = line.lineNo;
                                header.Lines.push(lineCopy);
                            }
                        }
                        //multipleResources = false;
                    }
                }
            }
            var url = this.$store.state.activeAPIurl + "api/jobtimeinput/updatejobtimeinput";
            var auxthis = this;
            auxthis.$store.commit('saveisLoading',true);
            this.axios.post(url,header,{headers: {"Content-Type": "application/json"}})
            .then(response => {      
                console.log(response);
                if (response.status == 200){                    
                    if (this.$store.state.user != ''){
                        this.clearAdditionalUsers(this.$store.state.parteDetalleObject.shipmentNo);
                        this.createDocumentRelation(response.data.inputNo,this.$store.state.parteDetalleObject.shipmentNo);
                    }
                    this.SetSignature(this.$store.state.signatureOrder,'Cabecera',response.data.inputNo,this.$store.state.usuario.name,0);
                    if (this.$store.state.signatureCustomer != ''){
                        this.SetSignature(this.$store.state.signatureCustomer,'Cliente',response.data.inputNo,this.$store.state.usuario.name,0);
                    }
                    for (i = 0; i< this.$store.state.lineasParte.length; i++){
                        this.SetSignature(this.$store.state.lineasParte[i].signatureStart,'Desde',response.data.inputNo,this.$store.state.usuario.name,(i+1)*10000);
                        this.SetSignature(this.$store.state.lineasParte[i].signatureEnd,'Hasta',response.data.inputNo,this.$store.state.usuario.name,(i+1)*10000);
                    }
                    /*if (this.$store.state.user.length > 0)
                        this.createDocumentRelation(response.data.inputNo);*/
                    this.sendImages(response.data.inputNo);
                    this.$router.push('Agenda');
                    this.$store.commit('resetDataAfterSuccessfulCreation');                    
                    this.getJobInputs();
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {   
                auxthis.$store.commit('saveisLoading',false);             
            });
        },
        readDocument(docNo){
            var url = this.$store.state.activeAPIurl + "api/jobtimeinput/jobtimeinputdetail";
            this.axios.post(url,{g: this.$store.state.usuario.guid, inputNo: docNo},{headers: {"Content-Type": "application/json"}})
            .then(response => { 
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                
                var doc = response.data;       
                doc.resourcesAditional = [];      
                var resEvent = this.$store.state.eventos.find( ev => { return ev.inputNo == doc.inputNo});
                if (resEvent){
                    doc.vb = resEvent.vb;
                    doc.posted = resEvent.posted;
                }
                this.$store.commit('saveParteDetalle',doc.inputNo);
                this.$store.commit('saveParteDetalleObject',doc);
                this.$store.commit('saveDriver', doc.driver);
                this.$store.commit('saveRevision', doc.revision);
                this.$store.commit('resetLines');
                this.getImages(docNo);
                this.getResourcesAditionalRelations(doc.shipmentNo);
                this.getAdditionalUsers(doc.shipmentNo);
                for (var i = 0; i < doc.Lines.length; i++){     
                    if (i == 0) {
                        this.getJobs();
                        this.$store.commit('saveJob',doc.Lines[i].jobNo);
                    }
                    var line = {
                        etag : doc.Lines[i].["@odata.etag"],                        
                        lineNo : doc.Lines[i].lineNo,
                        jobNo : doc.Lines[i].jobNo,
                        jobName : doc.Lines[i].jobName,
                        jobTaskNo: doc.Lines[i].jobTaskNo,
                        jobTaskName: doc.Lines[i].jobTaskName,
                        jobTaskLabel: doc.Lines[i].jobTaskNo + ' - ' + doc.Lines[i].jobTaskName,
                        Proyecto: doc.Lines[i].jobNo + ' - ' + doc.Lines[i].jobName,
                        hourCount: doc.Lines[i].timeCount,
                        jobTaskItemNo : doc.Lines[i].jobTaskItemNo,
                        invoiceableCount: doc.Lines[i].invoiceableTimeCount,
                        invoiceableCountUom: doc.Lines[i].invoiceableTimeCountUom,
                        familia: doc.Lines[i].familia,
                        workType: doc.Lines[i].workType,
                        startTime: this.formatTime(doc.Lines[i].startTime),
                        endTime: this.formatTime(doc.Lines[i].endTime),
                        startTimeInvoiceable: this.formatTime(doc.Lines[i].startTimeInvoiceable),
                        endTimeInvoiceable: this.formatTime(doc.Lines[i].endTimeInvoiceable),
                        signatureStart: '',
                        signatureEnd: '',
                        resource: doc.Lines[i].resource,                        
                        origen:  doc.Lines[i].origen,
                        destino:  doc.Lines[i].destino,
                        residuo: doc.Lines[i].residuo,
                        albaranFisico: doc.Lines[i].albaranFisico,
                        dieta: doc.Lines[i].dieta,
                        codIntCliente:  doc.Lines[i].codIntCliente,
                        taskDescription:  doc.Lines[i].taskDescription,
                        validated: doc.Lines[i].validated,
                        style: '',
                        note: doc.Lines[i].note,
                        adicional: doc.Lines[i].adicional,
                        invoiceableLine : doc.Lines[i].invoiceableLine,
                        resourceLine : doc.Lines[i].resourceLine
                    };
                    if (line.validated) line.style = 'validated';
                    this.$store.commit('addLine',line);
                    if (i == 0){
                        this.getJobTasks(line.jobNo);
                        this.$store.commit('saveFamilia',line.familia);
                        this.$store.commit('saveJobTask',line.jobTaskNo);
                    }
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });    
        },
        readRelatedDocument(shipmentNo){
            var url = this.$store.state.activeAPIurl + "api/jobtimeinput/jobtimeinputrelated";
            this.axios.post(url,{g: this.$store.state.usuario.guid, shipmentNo: shipmentNo},{headers: {"Content-Type": "application/json"}})
            .then(response => { 
                if (response.status == 204) store.state.dialogLogout = true;
                console.log(response);                
                var doc = response.data;                              
                for (var i = 0; i < doc.Lines.length; i++){     
                    if (i == 0) {
                        this.getJobs();
                        this.$store.commit('saveJob',doc.Lines[i].jobNo);
                        this.getJobTasks(doc.Lines[i].jobNo); 
                        this.$store.commit('saveJobTask',doc.Lines[i].jobTaskNo);
                        this.getFamilias(doc.Lines[i].jobNo);       
                        this.$store.commit('saveFamilia',doc.Lines[i].familia);
                        this.getJobTaskItemUom(doc.Lines[i].jobTaskItemNo);
                        this.getOrigenes(doc.Lines[i].jobNo);
                        this.getDestinos();
                        this.getResiduos();  
                        this.$store.commit('saveOrigen',doc.Lines[i].origen);
                        this.$store.commit('saveDestino',doc.Lines[i].destino);
                        this.$store.commit('saveResiduo',doc.Lines[i].residuo);
                        this.$store.commit('saveCodIntCliente',doc.Lines[i].codIntCliente);
                    }
                }
                this.getResourcesAditionalRelations(shipmentNo);
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });    
        },
        getImages(docNo){
            this.axios.post(this.$store.state.activeAPIurl + 'api/images/imagelist',     
            { inputNo : docNo},
            {headers: {"Content-Type": "application/json"}})
            .then((response) => {
                if (response.status == 200) {
                    console.log(response);
                    this.$store.commit('saveStoredImages',response.data.value);                                                   
                }
            })
            .catch(function (error) {
                // handle error
                console.log(error);                 
            })
            .finally(function () {                
            });     
        }
    }
}